import * as React from 'react';
import * as intl from 'react-intl-universal';
import { NavLink as Link } from 'react-router-dom';
import { RightOutlined } from '@ant-design/icons';
import Icon from 'common/components/IconFont';
import Badge from './Badge';

export default () => ({
    key: 'NOTICE',
    title: (totalCounts: number) => (
        <Badge counts={totalCounts} offset={[16, -13]} />
    ),
    children: (children: any[], totalCounts: number) =>
        children
            .splice(0, 5)
            .map(({ id, title, send_time, state }: any) => ({
                key: id,
                title: (
                    <Link
                        className="badge"
                        to={`/notification/message/all/detail/${id}`}
                    >
                        <div className="content" style={{ width: '0' }}>
                            <h3
                                style={{
                                    color: `${
                                        state == '1' ? '#535353' : '#3181cd'
                                    }`,
                                    whiteSpace: 'nowrap',
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                }}
                            >
                                {state == '0' && (
                                    <Icon
                                        className="anticon-point"
                                        style={{
                                            color: '#d53f3f',
                                            fontSize: '9px',
                                            marginRight: '2px',
                                        }}
                                    />
                                )}
                                {title}
                            </h3>
                            <p>{send_time}</p>
                        </div>
                        <div className="icon">
                            <RightOutlined />
                        </div>
                    </Link>
                ),
            }))
            .concat(
                totalCounts
                    ? [
                          {
                              key: 'checkMore',
                              title: (
                                  <Link
                                      to={'/notification/list/unread'}
                                      style={{ display: 'block' }}
                                  >
                                      <Icon
                                          className="anticon-examine"
                                          style={{ color: '#5992c8' }}
                                      />
                                      <span>
                                          {intl.get('Global.CheckMore')}
                                      </span>
                                  </Link>
                              ),
                          },
                      ]
                    : []
            ),
});
